import { line as lineD3, select } from "d3";
import { HoverElement } from "./HoverElement";

export class LineHover extends HoverElement {
  constructor(params) {
    super({ ...params });
    this.type = params.type;
    this.create(params.strokeColor, params.strokeWidth);
  }

  show({ yPixels, xPix }) {
    // Horizontal Line
    if (this.type === "h") {
      select(".hHoverLine" + this.name)
        .style("opacity", 1)
        .attr("y1", yPixels)
        .attr("y2", yPixels);
      // Vertical Line
    } else if (this.type === "v") {
      select(".vHoverLine" + this.name)
        .style("opacity", 1)
        .attr("x1", xPix)
        .attr("x2", xPix);
    }
  }

  create(strokeColor, strokeWidth = 1) {
    // Horizontal Line
    if (this.type === "h") {
      this.className = "hHoverLine" + this.name;
      this.svg.hLine = this.svg.append("g");
      this.svg.hLine
        .append("line")
        .attr("class", this.className)
        .style("opacity", 0)
        .attr("stroke", strokeColor)
        .attr("stroke-width", strokeWidth)
        .style("shape-rendering", "crispEdges")
        .attr("x1", 0)
        .attr("x2", this.svg.width);
      // Vertical Line
    } else if (this.type === "v") {
      this.className = "vHoverLine" + this.name;
      this.svg.hLine = this.svg.append("g");
      this.svg.hLine
        .append("line")
        .attr("class", this.className)
        .style("opacity", 0)
        .attr("stroke", strokeColor)
        .attr("stroke-width", strokeWidth)
        .style("shape-rendering", "crispEdges")
        .attr("y1", 0)
        .attr("y2", this.svg.height);
    }
  }

  recalculate({ xt, data, customName, fieldYName = "value" }) {
    if (this.type === "line") {
      const svg = this.svg;
      const line = lineD3()
        .x(d => xt(d.date))
        .y(d => svg.y(d[fieldYName]));

      svg[customName]
        .data([data])
        .join("path")
        .attr("d", line);
    }
  }
}
